import { API } from "aws-amplify";

const getActiveDropoff = async (callback) =>
  new Promise(async (resolve, reject) => {
    let dropoff = await API.get("check", "/dropoff/get");
    resolve(dropoff);
  });

export default getActiveDropoff;
